import { ProgressAccordion, Text } from '@medusajs/ui';

import { faqData } from '@lib/static/faq';
import BrandTitle from '@modules/common/components/brand-title';
import Breadcrumbs from '@modules/common/components/breadcrumbs';
import Container from '@modules/common/components/container';

const breadcrumbsItems = [
  { name: '首頁', href: '/' },
  { name: '常見問題', href: '' },
];

export default function FAQPage() {
  return (
    <Container className="my-12">
      <Breadcrumbs items={breadcrumbsItems} />
      <div className="my-12 flex justify-center">
        <BrandTitle title="常見問題" />
      </div>
      <div className="text-black-10 mx-auto max-w-[850px] px-4">
        <ProgressAccordion type="multiple">
          {faqData.map((faq) => (
            <ProgressAccordion.Item
              key={faq.question}
              value={faq.question}
              className="border-white-40 bg-white-20 border-b"
            >
              <ProgressAccordion.Header className="progressAccordion-header text-black-10 py-3">
                {faq.question}
              </ProgressAccordion.Header>
              <ProgressAccordion.Content>
                <div className="pb-6">
                  <Text size="small" className="whitespace-pre-line">
                    {faq.answer}
                  </Text>
                </div>
              </ProgressAccordion.Content>
            </ProgressAccordion.Item>
          ))}
        </ProgressAccordion>
      </div>
    </Container>
  );
}
